import { API_AUTH } from "../common";

const BaoCaoChiNhanhApi = {

    PhanQuyenBaoCaoChiNhanh: () =>
    API_AUTH.get(
        `bao-cao-tong-quan/phan-quyen-bao-cao-chi-nhanh`,
        {}
    ),

    CuaHangHienTai: (macuahang) =>
        API_AUTH.get(
            `bao-cao-chi-nhanh/thong-tin-cua-hang?macuahang=${macuahang}`,
            {}
        ),


    ThongKeHuyDongVon: (macuahang) =>
        API_AUTH.get(
            `bao-cao-chi-nhanh/thong-ke-huy-dong-von?macuahang=${macuahang}`,
            {}
        ),


    ThongKeDuNoChoVay: (macuahang) =>
        API_AUTH.get(
            `bao-cao-chi-nhanh/thong-ke-du-no-cho-vay?macuahang=${macuahang}`,
            {}
        ),

    ThongKeDongTien: (macuahang) =>
        API_AUTH.get(
            `bao-cao-chi-nhanh/thong-ke-dong-tien?macuahang=${macuahang}`,
            {}
        ),

    ThongKeHopDong: (macuahang) =>
        API_AUTH.get(
            `bao-cao-chi-nhanh/thong-ke-hop-dong?macuahang=${macuahang}`,
            {}
        ),


    ThongKeDangChoVay_CamDo: (macuahang) =>
        API_AUTH.get(
            `bao-cao-chi-nhanh/thong-ke-dang-cho-vay-cam-do?macuahang=${macuahang}`,
            {}
        ),

    ThongKeDangChoVay_TinChap: (macuahang) =>
        API_AUTH.get(
            `bao-cao-chi-nhanh/thong-ke-dang-cho-vay-tin-chap?macuahang=${macuahang}`,
            {}
        ),

    ThongKeDangChoVay_TraGop: (macuahang) =>
        API_AUTH.get(
            `bao-cao-chi-nhanh/thong-ke-dang-cho-vay-tra-gop?macuahang=${macuahang}`,
            {}
        ),

};

export default BaoCaoChiNhanhApi;
